import React, { useEffect, useContext, useState } from 'react';
import { TabberContext } from './Tabber.provider';

import './Tabber.styles.scss';

export const Tabber = ({ children }) => {
	const { tabberData, setTabberData } = useContext(TabberContext);

	useEffect(() => {
		let newarr = children.map((child, index) => {
			return { id: index, name: child.props?.name };
		});

		setTabberData({ ...tabberData, tabs: newarr });
	}, []);

	return (
		<div className="tabs">
			{tabberData.tabs &&
				children.map((child, index) =>
					React.cloneElement(child, { data: tabberData.tabs[index], selectedChild: tabberData.selected, key: index })
				)}
		</div>
	);
};

export const TabMenu = () => {
	const { tabberData, setTabberData } = useContext(TabberContext);
	const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

	const setIndex = (index) => {
		setTabberData({ ...tabberData, selected: index });
		setMobileMenuOpen(false); // Close menu after selection
	};

	return (
		<>
			{/* Mobile hamburger button */}
			<button 
				className="mobile-menu-toggle"
				onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
				aria-label="Toggle menu"
			>
				<span></span>
				<span></span>
				<span></span>
			</button>
			
			{/* Mobile menu overlay */}
			{mobileMenuOpen && (
				<div className="mobile-menu-overlay" onClick={() => setMobileMenuOpen(false)}></div>
			)}
			
			{/* Menu container */}
			<div className={`tab-menu ${mobileMenuOpen ? 'mobile-open' : ''}`}>
				{tabberData.tabs &&
					tabberData.tabs.map((item) => (
						<div key={item.id} className={`tab-item ${item.id === tabberData.selected ? 'selected' : ''}`} onClick={() => setIndex(item.id)}>
							{item.name}
						</div>
					))}
			</div>
		</>
	);
};

export const Tab = ({ children, data, selectedChild }) => {
	return <>{data?.id === selectedChild && <div className={`tab ${data?.id === selectedChild ? 'visible' : ''}`}>{children}</div>}</>;
};
